import { hasWindow } from "@omni/utils/dom.utils";

if (hasWindow()) window[LIB_NAME] = window[LIB_NAME] || {};

export enum WindowKeys {
    FEATURE_TOGGLES = "featureToggles",
    TRACKER = "tracker",
    VERSION = "version",
    SEARCH = "search",
    HOOKS = "hooks",
    MOCK_DATE = "mockDate"
}

export const saveObject = (key: string, value: any) => {
    if (hasWindow()) {
        window[LIB_NAME][key] = value;
    }
};

export const getObject = (key: string) => {
    return hasWindow() ? window[LIB_NAME][key] : undefined;
};
